import { render, staticRenderFns } from "./mgrStudentChangeDate.vue?vue&type=template&id=058b237a&scoped=true&"
import script from "./mgrStudentChangeDate.vue?vue&type=script&lang=js&"
export * from "./mgrStudentChangeDate.vue?vue&type=script&lang=js&"
import style0 from "./mgrStudentChangeDate.vue?vue&type=style&index=0&id=058b237a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b237a",
  null
  
)

export default component.exports